import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ProductService } from '@app/api/api';
import { Subscription, Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { UtilService } from '@app/services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { currentUser, isLoggedIn } from '@app/core/auth';
import { AppState } from '@app/core/reducers';
import { select, Store } from '@ngrx/store';
import { User } from '@app/model/user';

@Component({
  selector: 'app-discount-products',
  templateUrl: './discount-products.component.html',
  styleUrls: ['./discount-products.component.scss'],
})
export class DiscountProductsComponent implements OnInit, OnDestroy {
products: Array<{
    id?: number;
    name: string;
    price: number;
    origin_price: number;
    sale_off?: number;
    seo_name?: string;
}> = [];
  private subscriptions: Subscription[] = [];
  host = environment.backendhost;

  pageSize: number = 18;
  pageIndex: number = 1;
  totalItems: number = 0;
  showPrice: boolean = false;
  user$: Observable<User>;

  constructor(
    private productService: ProductService,
    public translate: TranslateService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadProducts();
    // isLoggedIn — có giá trị ngay khi Login action dispatch
    this.store.pipe(select(isLoggedIn)).subscribe(loggedIn => {
      if (loggedIn) {
        this.showPrice = true;
      } else {
        const token = localStorage.getItem(environment.authTokenKey);
        this.showPrice = !!(token && token.length > 10);
      }
      this.cdr.detectChanges();
    });

    this.user$ = this.store.pipe(select(currentUser));
    this.user$.subscribe((res) => {
      if (res) {
        this.showPrice = true;
        this.cdr.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  loadProducts() {
    this.subscriptions.push(
      this.productService
        .apiProductsDiscountGet('is_hidden==false', '', this.pageIndex, this.pageSize)
        .subscribe((res) => {
          this.products = res.data.collection;
          this.totalItems = res.data.total;
          this.products.forEach((item) => {
            item.sale_off = Math.round(100 - (item.price / item.origin_price) * 100);
            item.seo_name = UtilService.slugify(item.name);
          });
          this.cdr.detectChanges();
        })
    );
  }

  onPageChange(page: number) {
    this.pageIndex = page;
    this.loadProducts();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
